








import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    coverURL: String
  }
})
export default class Vinyle extends Vue {
}
